export default __webpack_public_path__ + "static/media/09_photo.19c95c13.jpg";